import PropTypes from 'prop-types';

export const propTypes = {
  names: PropTypes.array.isRequired,
};
